export default __webpack_public_path__ + "static/media/liverpool.06c87f04.jpg";